<template>
  <v-data-table
    v-if="giftCardResults && giftCard.searched"
    :headers="giftCardHeaders"
    :items="giftCardResults"
    :items-per-page="5"
    class="elevation-1"
    :no-data-text="'No results found.'"
  >
    <template slot="item" slot-scope="props">
      <tr>
      <td>
        <span v-if="props.item.location_code">
          {{ props.item.location_code }}
        </span>
        <span v-else>N/A</span>
      </td>
      <td>{{ props.item.recipient_name }}</td>
      <td>{{ props.item.email_address }}</td>
      <td>${{ props.item.rent_rate }}</td>
      <td>${{ props.item.card_amount }}</td>
      <td>{{ convertDate(props.item.move_in_date) }}</td>
      <td>
        <span v-if="props.item.eligible_at">{{ convertDate(props.item.eligible_at) }}</span>
        <span v-else>N/A</span>
      </td>
      <td>
        <span v-if="props.item.reward_status === 'Issued'" class="success--text">{{ props.item.reward_status }}</span>
        <span v-else-if="props.item.reward_status === 'denied'" class="error--text">
          {{ capitalizeFirst(props.item.reward_status) }}
        </span>
        <span v-else>N/A</span>
      </td>
      <td>
        <span v-if="props.item.issued_at">{{ convertDate(props.item.issued_at) }}</span>
        <span v-else>N/A</span>
      </td>
      <td>
        <span v-if="props.item.confirmation_number">{{ props.item.confirmation_number }}</span>
        <span v-else>N/A</span>
      </td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { giftCardHeaders } from "@/helpers/gift-cards/gift-cards-data-table-headers";
import moment from "moment";

export default {
  data() {
    return {
      giftCardHeaders: giftCardHeaders
    };
  },
  // ===== Methods ===== //
  methods: {
    capitalizeFirst(text) {
      return text.charAt(0).toUpperCase() + text.slice(1);
    },
    convertDate(date) {
      return moment.utc(date).format("MM/DD/YYYY");
    }
  },

  // ===== Computed ===== //
  computed: {
    giftCard() {
      return this.$store.state.giftCards;
    },
    giftCardResults() {
      return this.giftCard.giftCards ? this.$store.state.giftCards.giftCards : [];
    }
  }
};
</script>
